import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { AcceptanceFlows } from 'src/app/flows/acceptance.flows';
import { UserFlows } from 'src/app/flows/user.flows';
import { AuthFlows } from '../flows/auth.flows';
import { CartService } from '../shared/cart.service';

@Component({
  selector: 'app-social-auth-options',
  templateUrl: './social-auth-options.component.html',
  styleUrls: ['./social-auth-options.component.scss'],
  standalone: false
})
export class SocialAuthOptionsComponent implements OnInit {

  loading;
  returnPath = '/';

  constructor(
    private userFlows: UserFlows,
    private acceptanceFlows: AcceptanceFlows,
    public router: Router,
    private loadingController: LoadingController,
    private cartService: CartService,
    private authFlow: AuthFlows
  ) { }

  ngOnInit() { }

  async doFacebookLogin() {
    if (await this.authFlow.presentAcceptance()) {
      this.presentLoading();
      this.userFlows.doSignupFacebook()
        .then((user) => {
          this.acceptanceFlows.userAcceptance(user);
          this.loading.dismiss();
          if (this.cartService.currentStep === 1) {
            this.router.navigate(['/cart']);
          } else {
            this.router.navigate([this.returnPath]);
          }
        })
        .catch(res => {
          console.log('===>> ERROR FB:');
          console.log(res);
          this.authFlow.handleAuthError(res);
          this.loading.dismiss();
        });
    } else {
      throw "error";
    }
  }


  async presentLoading() {
    this.loading = await this.loadingController.create({
      message: 'Espera por favor...'
    });
    this.loading.present();
  }

  async doGoogleLogin() {
    if (await this.authFlow.presentAcceptance()) {
      this.presentLoading();

      try {
        const user = await this.userFlows.doSignupGoogle();
        this.acceptanceFlows.userAcceptance(user);
        this.loading.dismiss();
        if (this.cartService.currentStep === 1) {
          this.router.navigate(['/cart']);
        } else {
          this.router.navigate([this.returnPath]);
        }
      } catch (res) {
        console.error(res);
        this.authFlow.handleAuthError(res);
        this.loading?.dismiss();
      }
    } else {
      throw "error";
    }
  }

}

